import { FileTextIcon, ZapIcon, BotIcon, ClipboardListIcon, ShieldCheckIcon, InfinityIcon } from 'lucide-react';
export const heroChips = [{
  icon: FileTextIcon,
  label: '100% Digital PDF'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: BotIcon,
  label: 'Designed for compatible AI assistants'
}, {
  icon: ClipboardListIcon,
  label: 'Ready-to-Customize Prompts'
}];
export const heroTopics = ['Security Reports', 'Patrol & Site Operations', 'Shift Handovers', 'Risk Assessment', 'Client Communication', 'Supervision'];
export const stats = [{
  value: '500+',
  label: 'Satisfied Users'
}, {
  value: "6\xA0 +\xA0 4",
  label: "Volumes\xA0 +\xA0 Bonuses"
}, {
  value: '99%',
  label: 'Recommend it'
}, {
  value: '4.9/5',
  label: '⭐ Global Rating'
}];